
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchConveniosPorVencer"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchConveniosPorVencer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vigente"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuilDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuotas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaPrimerPago"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deudas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idDeuda"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capitalTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intereses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imputadoCobranzas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cobranzas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaCobranza"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoCobrado"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fechaUltimaCobranza"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fueraDePauta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quitaEspecial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaPrimerPago"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoCuota"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"origen"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exito"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telefono"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userAgent"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pagos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fechaPago"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaComprobante"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaVencimiento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verificado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuota"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parcial"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"metricas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagosVencidos"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pagosCobrados"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoVencido"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoCobrado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoFaltante"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"porcentajeVencido"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1098}};
    doc.loc.source = {"body":"query fetchConveniosPorVencer{\n    fetchConveniosPorVencer{\n\n        id\n        estado\n        vigente\n        dniDeudor\n        cuilDeudor\n        cuotas\n        montoTotal\n        fechaPrimerPago\n        deudas{\n            id\n            idDeuda\n            capitalTotal\n            intereses\n            imputadoCobranzas\n            estado\n        }\n        cobranzas{\n            id\n            fechaCobranza\n            montoCobrado\n        }\n        fechaUltimaCobranza\n        fueraDePauta\n        quitaEspecial\n        fechaPrimerPago\n        montoCuota\n        createdAt\n        origen\n        exito{\n            nombre\n            email\n            telefono\n            ip\n            userAgent\n        }\n        pagos {\n            fechaPago\n            fechaComprobante\n            fechaVencimiento\n            verificado\n            cuota\n            monto\n            parcial\n        }\n        metricas {\n            pagosVencidos\n            pagosCobrados\n            montoVencido\n            montoCobrado\n            montoFaltante\n            porcentajeVencido\n        }\n    }\n\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["fetchConveniosPorVencer"] = oneQuery(doc, "fetchConveniosPorVencer");
        
